export default __webpack_public_path__ + "static/media/Front-Commercial-Center-Kongo.5c9a2902.jpg";